/**
 * Component <e2-loading /> is used to show loading indicator when the content is loading.
 *
 * @attr {string} name - The name of the field in the store to check loading state
 * @attr {boolean} [hide-loading-icon] - if defined then loading icon is not shown
 *
 * HTML Structure Example
 *
 * <e2-loading store-name="orders.isLoading">
 *      CONTENT BEING WRAPPED
 * </e2-loading>
 */

import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { getValueByStorePath } from '@elab/core/utils/helpers';

class Loading extends LightLitElement {
    static get properties() {
        return {
            name: {
                type: String,
            },
            fieldValue: {
                type: String,
            },
            hideLoadingIcon: {
                type: Boolean,
                attribute: 'hide-loading-icon',
            },
            showLoadingIcon: {
                type: Boolean,
                attribute: 'show-loading-icon',
            },
            toggleLoadingIcon: {
                type: Boolean,
                attribute: 'toggle-loading',
            },
        };
    }

    constructor() {
        super();
        this.hideLoadingIcon = false;
        this.showLoadingIcon = false;
        this.toggleLoadingIcon = false;
    }

    getLoaderClass() {
        return `loader ${
            this.fieldValue || this.toggleLoadingIcon || this.showLoadingIcon
                ? 'loader--loading'
                : ''
        }`;
    }

    render() {
        return html`
            <div class="${this.getLoaderClass()}">
                <v-slot></v-slot>
                ${this.hideLoadingIcon
                    ? ''
                    : html`
                          <i class="loader__loading-icon"></i>
                      `}
                <div class="loader__label">
                    <v-slot name="loading-label"></v-slot>
                </div>
            </div>
        `;
    }
}

const mapStateToProps = (state, ctx) => ({
    fieldValue: ctx.name ? getValueByStorePath(ctx.name, state) : '',
});

export default () => customElements.define('e2-loading', connect(mapStateToProps)(Loading));
